/**
 * Price calculation utilities for product bundles
 * Handles all price-related calculations: bike price, addons, discounts, totals
 */
(function() {
    'use strict';
    
    window.BundlePriceCalculator = window.BundlePriceCalculator || {};

    /**
     * Calculate discount amount from discount code mapping
     * @param {string} discountCode - The discount code (e.g., 'VIP55', 'Subscriber')
     * @param {number} bikePriceCents - Bike price in cents
     * @returns {number} Discount amount in cents
     */
    window.BundlePriceCalculator.calculateDiscountFromCode = function(discountCode, bikePriceCents) {
    if (!discountCode || !bikePriceCents) return 0;
    
    const DISCOUNT_MAP = {
        'Subscriber': { type: 'fixed_per_item', amount: 235000 }, // $2,350.00 per item
        'SUBSCRIBER': { type: 'fixed_per_item', amount: 235000 },
        'subscriber': { type: 'fixed_per_item', amount: 235000 },
        'VIP55': { type: 'fixed_per_item', amount: 255400 }, // $2,554.00 per item
        'TELEPORT55': { type: 'percentage', percentage: 0.55 }, // 55% off order
        'TELEPORT50': { type: 'percentage', percentage: 0.50 }, // 50% off order
        'VIP100': { type: 'fixed_order', amount: 10000 }, // $100.00 off order
        'Subscribers': { type: 'fixed_per_item', amount: 190000 }, // $1,900.00 per item
        'VIP': { type: 'fixed_per_item', amount: 210000 }, // $2,100.00 per item
    };
    
    const normalizedCode = discountCode.trim();
    const discountInfo = DISCOUNT_MAP[normalizedCode] || 
                       DISCOUNT_MAP[normalizedCode.toUpperCase()] || 
                       DISCOUNT_MAP[normalizedCode.toLowerCase()];
    
    if (!discountInfo) return 0;
    
    if (discountInfo.type === 'fixed_per_item') {
        return discountInfo.amount; // Already in cents
    } else if (discountInfo.type === 'fixed_order') {
        return discountInfo.amount; // Already in cents
    } else if (discountInfo.type === 'percentage') {
        return Math.round(bikePriceCents * discountInfo.percentage);
    }
    
    return 0;
}

    /**
     * Parse price text to cents
     * @param {string} priceText - Price text (e.g., "$1,995.00")
     * @returns {number} Price in cents
     */
    window.BundlePriceCalculator.parsePriceToCents = function(priceText) {
    if (!priceText) return 0;
    const cleaned = priceText.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const dollars = parseFloat(cleaned) || 0;
    return Math.round(dollars * 100);
}

    /**
     * Calculate bike price from selected variant
     * @param {HTMLElement} bundleElement - The bundle element
     * @returns {number} Bike price in cents
     */
    window.BundlePriceCalculator.calculateBikePrice = function(bundleElement) {
    const mainProductItem = bundleElement.querySelector('.bundle-product-itemFirst, .bundle-product-item:first-child');
    if (!mainProductItem) return 0;
    
    const selectElement = mainProductItem.querySelector('select[name=group_id]');
    if (!selectElement) return 0;
    
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    if (!selectedOption) return 0;
    
    const priceAttr = selectedOption.getAttribute('data-price');
    if (!priceAttr) return 0;
    
    return parseInt(priceAttr) || 0;
}

    /**
     * Calculate addons total from all addon items
     * @param {HTMLElement} bundleElement - The bundle element
     * @returns {number} Addons total in cents
     */
    window.BundlePriceCalculator.calculateAddonsTotal = function(bundleElement) {
    let addonsTotalCents = 0;
    
    const addonItems = Array.from(bundleElement.querySelectorAll('.bundle-product-item')).slice(1); // Skip first (main product)
    
    addonItems.forEach((item) => {
        const checkbox = item.querySelector('[data-bundle-checkbox]');
        if (!checkbox || !checkbox.checked) return;
        
        const selectElement = item.querySelector('select[name=group_id]');
        if (!selectElement) return;
        
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        if (!selectedOption) return;
        
        const priceAttr = selectedOption.getAttribute('data-price');
        if (priceAttr) {
            addonsTotalCents += parseInt(priceAttr) || 0;
        }
    });
    
    return addonsTotalCents;
}

    /**
     * Calculate final total price
     * @param {number} bikePriceCents - Bike price in cents
     * @param {number} addonsTotalCents - Addons total in cents
     * @param {number} discountAmountCents - Discount amount in cents
     * @returns {number} Final total in cents
     */
    window.BundlePriceCalculator.calculateFinalTotal = function(bikePriceCents, addonsTotalCents, discountAmountCents) {
        const discountedBikePrice = bikePriceCents - discountAmountCents;
        return discountedBikePrice + addonsTotalCents;
    };
})();
